<header>
  <nav class="nav d-flex justify-content-center justify-content-md-start align-items-center">
    <a class="brand" [routerLink]="['/']">
      <img class="logo" src="./assets/images/realty-bid-logo-full.svg" alt="logo" />
    </a>
    <button pButton class="p-button-text d-md-none close-button" icon="pi pi-times" (click)="close()"></button>
  </nav>
</header>
